import { useState, useEffect, useCallback } from 'react';
import { bgvService } from '../services/bgv';
import type { BgvPendingReview } from '../types/bgv';

interface UseBgvPendingReviewsReturn {
  items: BgvPendingReview[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useBgvPendingReviews(): UseBgvPendingReviewsReturn {
  const [state, setState] = useState<{
    items: BgvPendingReview[];
    loading: boolean;
    error: string | null;
  }>({
    items: [],
    loading: true,
    error: null,
  });

  const fetch = useCallback(async () => {
    setState((prev) => ({ ...prev, loading: true, error: null }));
    try {
      const data = await bgvService.getPendingReviews();
      setState({ items: Array.isArray(data) ? data : [], loading: false, error: null });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to fetch pending reviews';
      setState((prev) => ({ ...prev, loading: false, error: message }));
    }
  }, []);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { ...state, refetch: fetch };
}
